import { recoveryRedirectHref } from './authRecovery'

/**
 * Runs at module load, before the Supabase client is created.
 * Recovery tokens that land on Site URL (/) must be moved to /reset-password
 * before detectSessionInUrl or AdminProtectedRoute can drop them.
 */
if (typeof window !== 'undefined') {
  const href = recoveryRedirectHref(
    window.location.pathname,
    window.location.hash,
    window.location.search
  )
  if (href) {
    window.location.replace(href)
  }
}
